module.exports = __webpack_public_path__ + "static/11-ddb9bc839b361214fb63260852668da2.jpg";